import Paper from 'components/Paper'
import { ParametersSectionWrapperProps } from './types'

export const ParametersSectionWrapper = ({
  accountType,
  children,
}: ParametersSectionWrapperProps): React.JSX.Element =>
  accountType === 'own' ? <Paper>{children}</Paper> : <Paper variant='cream'>{children}</Paper>
